export default function ProfileInfo({ user, onEdit }) {
  return (
    <div className="profileInfoCard">
      <div className="profileInfoGrid">
        <InfoItem label="Prénom" value={user.firstName} />
        <InfoItem label="Nom" value={user.lastName} />
        <InfoItem label="Email" value={user.email} />
        <InfoItem label="Téléphone" value={user.phone || "-"} />
        <InfoItem label="WhatsApp" value={user.contact?.whatsapp || "-"} />
        <InfoItem label="Adresse" value={user.contact?.adress || "-"} />

      </div>

      <div className="profileInfoActions">
        {/* <button className="btnPrimary" onClick={onEdit}>
          Modifier le profil
        </button> */}
        <button className="btnGhost" onClick={onEdit}>
       Modifier le profil
      </button>
      </div>
    </div>
  );
}

function InfoItem({ label, value }) {
  return (
    <div className="profileInfoItem">
      <span className="profileInfoLabel">{label}</span>
      <span className="profileInfoValue">{value}</span>
    </div>
  );
}
